import BigNumber from "bignumber.js";

export const pageKeys = {
  summary: 414,
  detail: 415,
}

// 保留table的晒选条件
let selectorValues = {
  filterType: 1
}

// 记录晒选条件的状态
export function recordSelector(values){
  selectorValues = { ...selectorValues, ...values} 
}

// table求和配置
const tableSumConfig = {
  // 业绩汇总
  414: {
    cond: () => true,
    sumKeys: [
      'sales_money',
      'invite_business_num',
      'invite_shop_num',
      'service_business_num',
      'service_shop_num',
      'new_order_business_num',
      'new_order_shop_num',
      'order_business_num',
      'order_shop_num',
      'receive_money',
      'sales_money'
    ]
  },
  // 业绩明细
  415: {
    cond: ()=> [8, 9].includes(selectorValues.filterType),
    sumKeys: [
      'sales_money', 
      'receive_money',
    ]
  }
}

export function sumDataCol(data, key){
  const res =  data.reduce((pre, cur)=> pre.plus(cur[key] || 0), new BigNumber(0))
  return res.toString()
}


// 对table数据进行求和
export function useTableSumData(params, compId){
  const { columns, data } = params
  if(!Array.isArray(data) || data.length === 0) return []
  if(!tableSumConfig.hasOwnProperty(compId) || !tableSumConfig[compId].cond()) return []

  const { sumKeys } = tableSumConfig[compId]
  const res = columns.map((item, index) => {
    if (index === 0) return '合计'
    if (sumKeys.includes(item.property)) return sumDataCol(data, item.property)
    return ''
  })
  return res
}

/**
 * 更改el-table第几行第几列的文字
 */
export function changeTableText(table, row, col, text){
    const selector = `.el-table__fixed-body-wrapper .el-table__row:nth-child(${row+1}) td:nth-child(${col+1}) span`
    let span = table.querySelector(selector)
    span && (span.innerHTML = text)
}